import React from 'react'
import './Spinner.scss'
const Spinner = () => {
  return (
    <div className='loader'></div>
  )
}

export default Spinner